import React, {useState} from "react";
import {Box, Button, Checkbox, Column, Columns, Input, TextArea, Title} from "@allxsmith/bestax-bulma";
import TaxTypePicker from "./TaxTypePicker";


export default function NewNominalCode({onSave}){
    const [code, setCode] = useState({});

    const onChange = e => {
        let newCode = {...code, [e.target.name]: e.target.value}
        setCode(newCode);
    };

    const onCheck = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !code[e.target.name]
            }
        };
        onChange(toUpdate);
    }

    const handleSave = (code) => {
        if(!(!!code.tax_type)){
            const toUpdate = {
                target: {
                    name: "tax_type",
                    value: "OUTPUT2"
                }
            }
            onChange(toUpdate);
        }
        onSave(code)
    }

    return (
        <Box>
            <details>
                <summary><Title>Add Nominal Code</Title></summary>
            <Columns isMultiline>
                <Column>
                    <label className="label">Name</label>
                    <Input
                        type={"text"}
                        name={"name"}
                        value={code.name}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Code</label>
                    <Input
                        type={"text"}
                        name={"code"}
                        value={code.code}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Type</label>
                    <Input
                        type={"text"}
                        name={"type"}
                        value={code.type}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <TaxTypePicker
                        label={"Tax Type"}
                        onChange={onChange}
                        value={code.tax_type}
                        name={"tax_type"}
                        disabled={false}
                    />
                </Column>
                <Column>
                    <label className="label">Bank Account Number</label>
                    <Input
                        type={"text"}
                        name={"bank_account_number"}
                        value={code.bank_account_number}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Description</label>
                    <TextArea
                        name={"description"}
                        value={code.description}
                        onChange={onChange}
                    />
                </Column>
                <Column>
                    <label className="label">Enable Payments To Account</label>
                    <Checkbox
                        name={"enable_payments_to_account"}
                        checked={code.enable_payments_to_account}
                        onChange={onCheck}
                    />
                </Column>
                <Column>
                    <label className="label">Show In Expense Claims</label>
                    <Checkbox
                        name={"show_in_expense_claims"}
                        checked={code.show_in_expense_claims}
                        onChange={onCheck}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => handleSave(code)}
                        isFullWidth
                    >
                       Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}